import superagent from 'superagent'

//For getting details from the map to open the Private land Details
export const landTrustRightMenuBarOpen = payload => ({
    type: 'LANDTRUST_RIGHT_MENU_OPEN',
    payload: payload
})

export const landTrustRightMenuBarClose = payload => ({
    type: 'LANDTRUST_RIGHT_MENU_CLOSE',
})


//For details of an item
export const landTrustDetailsMenuBarexpand = (payload) => ({
    type: 'LANDTRUST_DETAILS_MENU_EXPAND',
    payload: payload
})

export const landTrustDetailsMenuBarHide = () => ({
    type: 'LANDTRUST_DETAILS_MENU_HIDE',
})

// for list of all items menu
export const landTrustRightMenuBarexpand = () => ({
    type: 'LANDTRUST_RIGHT_MENU_EXPAND',
})

export const landTrustRightMenuBarHide = () => ({
    type: 'LANDTRUST_RIGHT_MENU_HIDE',
})